import React, { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Col, Row } from "reactstrap";
import Spinner from "../../Common/Spinner";
import { useSelector, useDispatch } from "react-redux";
import { fetchCandidateDetailRequest } from "../../../redux/recruiter/fetch_candidate_detail/actions";
import { shiftTypeOptions, jobTypeOptions, AVATAR, employmentTypeOptions } from "../../../Constant";
import { capitalize, formatExperienceYearAndMonth, handleCopyToClipboard, formatDate, handlePhoneCall, handleSendEmail } from "../../Common/CommonFunction";
import { addContactedCountRequest } from "../../../redux/jobseeker/add_contacted_count/actions";
import { IoCallOutline } from "react-icons/io5";
import { IoMdCopy } from "react-icons/io";
import { RiMailSendLine } from "react-icons/ri";
import { RiDeleteBinLine } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";

const ViewCandidateDetailModal = (props) => {
  const { isOpen, toggleModal, seekerId } = props;
  const { isLoading, data, error } = useSelector((state) => state.fetchCandidateDetailReducer);
  console.log("data66", data);
  const [selectedFile, setSelectedFile] = useState(null);
  const dispatch = useDispatch();
  const emptyField = (str) => {
    if (str === null || "") {
      return "-";
    } else {
      return str;
    }
  };
  useEffect(() => {
    if (seekerId) {
      dispatch(fetchCandidateDetailRequest({ seeker_id: seekerId })); // Dispatch action to fetch candidate details
    }
  }, [isOpen, seekerId, dispatch]);
  const handleCopyClick = (data, seekerId) => {
    handleCopyToClipboard(data);
    dispatch(addContactedCountRequest({ seeker_id: seekerId }));
  };
  const handlePhoneClick = (phone, seekerId) => {
    handlePhoneCall(phone);
    dispatch(addContactedCountRequest({ seeker_id: seekerId })); // Dispatch your action with the necessary payload
  };

  const handleMailClick = (email, seekerId) => {
    handleSendEmail(email);
    dispatch(addContactedCountRequest({ seeker_id: seekerId })); // Dispatch your action with the necessary payload
  };
  if (!data) return <Spinner />;

  return (
    <Modal
      isOpen={props.isOpen}
      toggle={props.toggleModal}
      centered
      className="modal-md"
    >
      <ModalHeader toggle={props.toggleModal}>
        {/* {props.data.resume_name} */}
        Basic Info
      </ModalHeader>
      <ModalBody  >
        {isLoading ? (
          <Spinner /> // Display spinner while loading
        ) : (
          <>
            <div className="profile_img_container d-flex justify-content-between  position-relative ">
              <div className="d-flex align-items-center">
                {selectedFile ? (
                  <img
                    src={URL.createObjectURL(selectedFile)}
                    alt="Company logo"
                    className="rounded-circle profile_img"
                    width="80px"
                    height="80px"
                    style={{ objectFit: "cover" }}
                  />
                ) : data.jobseeker_photo ? ( // Check if jobseeker_photo is not null or empty
                  <img
                    src={data.jobseeker_photo}
                    alt="Company logo"
                    className="rounded-circle profile_img"
                    width="80px"
                    height="80px"
                    style={{ objectFit: "cover" }}
                  />
                ) : (
                  <img
                    src={AVATAR}
                    alt="Default avatar"
                    className="rounded-circle profile_img"
                    width="80px"
                    height="80px"
                    style={{ objectFit: "cover" }}
                  />
                )}
                {/* {type == "view" ? null : (
              <div
                className="icon_overlay text-center"
                style={{ left: "40px" }}
              >
                <label htmlFor="fileInput">
                  <FiEdit className="edit-icon text-white" size={18} />
                </label>

                <input
                  type="file"
                  id="fileInput"
                  style={{ display: "none" }}
                  // onChange={handleFileChange}
                  accept="image/*"
                />

                {(selectedFile || (data.jobseeker_photo && data.jobseeker_photo !== "")) && (
                  <RiDeleteBinLine
                    className="delete-icon text-red"
                    size={18}
                    onClick={() => {
                      // handleProfileDeleteClick();
                    }}
                    style={{ cursor: 'pointer' }} // Add cursor style
                  />
                )}
              </div>
            )} */}

                <div className="media-body" style={{ marginLeft: 14 }}>
                  <a
                  // to={`${process.env.PUBLIC_URL}/app/users/userProfile/${layoutURL}`}
                  >
                    <h4 attrH5={{ className: "mb-1" }} style={{ wordBreak: "break-word" }}>
                      {capitalize(emptyField(data.jobseeker_full_name))}
                    </h4>
                  </a>
                  {/* <p>DESIGNER</p> */}
                </div>
              </div>

              {/* {type == "view" ? null : (
                     <div className="ml-auto">
                       <Button
                         color="primary"
                         className="btn  btn-sm  "
                         style={{
                           display: "flex",
                           alignItems: "center",
                           marginTop: -36,
                           paddingRight: "1rem",
                           paddingLeft: "1rem",
                         }}
                         onClick={OpenEditPersonal}
                       >
                         <MdOutlineModeEdit size={18} style={{ marginRight: 2 }} />{" "}
                         Edit
                       </Button>
                     </div>
                   )} */}
              {/* {type === "view" ? null : (
            <div className="ml-auto">
              <FiEdit
                className="edit-icon "
                size={22}
                // onClick={OpenEditPersonal}
                title="Edit"
              />
            </div>
          )} */}
            </div>
            {/* {fileError && <small className="text-danger">{fileError}</small>} */}
            <div className="">
              <Row className="mt-3" style={{ lineHeight: "inherit" }}>
                <Col xs="5" className="fw-bold p-0 ps-3">
                  Email
                  <span style={{ float: "right" }}> : </span>
                </Col>

                <Col xs="7">
                  {data.jobseeker_email1 ? (
                    <div>
                      <a
                        href={`mailto:${emptyField(
                          data.jobseeker_email1.trim()
                        )}`}
                        style={{ marginRight: 5 }}
                      >
                        {emptyField(data.jobseeker_email1.trim()).length >
                          17
                          ? emptyField(
                            data.jobseeker_email1.trim()
                          ).substring(0, 17) + "..."
                          : emptyField(data.jobseeker_email1.trim())}
                      </a>
                      <RiMailSendLine
                        className="email-icon"
                        title="Email"
                        size={22}
                        style={{ verticalAlign: "middle", cursor: "pointer" }}
                        onClick={() =>
                          handleMailClick(
                            data.jobseeker_email1,
                            data.jobseeker_id
                          )
                        }
                      />{" "}
                      <IoMdCopy
                        className="copy-icon "
                        size={22}
                        style={{ verticalAlign: "middle", cursor: "pointer" }}
                        onClick={() =>
                          handleCopyClick(
                            data.jobseeker_email1,
                            data.jobseeker_id
                          )
                        }
                        title="Copy"
                      />{" "}
                    </div>
                  ) : (
                    "N/A"
                  )}
                </Col>
              </Row>

              <Row className="mt-2" style={{ lineHeight: "inherit" }}>
                <Col xs="5" className="fw-bold p-0 ps-3">
                  Email2
                  <span style={{ float: "right" }}> : </span>
                </Col>

                <Col xs="7">
                  {data.jobseeker_email2 ? (
                    <div>
                      <a
                        href={`mailto:${emptyField(
                          data.jobseeker_email2.trim()
                        )}`}
                        style={{ marginRight: 5 }}
                      >
                        {/* {emptyField(email.trim())} */}
                        {emptyField(data.jobseeker_email2.trim()).length >
                          17
                          ? emptyField(
                            data.jobseeker_email2.trim()
                          ).substring(0, 17) + "..."
                          : emptyField(data.jobseeker_email2.trim())}
                      </a>
                      <RiMailSendLine
                        className="email-icon "
                        size={22}
                        style={{ verticalAlign: "middle", cursor: "pointer" }}
                        onClick={() =>
                          handleMailClick(
                            data.jobseeker_email2,
                            data.jobseeker_id
                          )
                        }
                        title="Mail"
                      />{" "}
                      <IoMdCopy
                        className="copy-icon"
                        size={22}
                        style={{ verticalAlign: "middle", cursor: "pointer" }}
                        onClick={() =>
                          handleCopyClick(
                            data.jobseeker_email2,
                            data.jobseeker_id
                          )
                        }
                        title="Copy"
                      />
                      {/* Icon for copying email */}
                    </div>
                  ) : (
                    "N/A"
                  )}
                </Col>
              </Row>

              <Row className="mt-2">
                <Col
                  xs="5"
                  className=" p-0 ps-3 fw-bold"
                  style={{ lineHeight: "inherit" }}
                >
                  Phone <span style={{ float: "right" }}> : </span>
                </Col>
                <Col xs="7">
                  {data.jobseeker_phone1 ? (
                    <div>
                      <span style={{ marginRight: 5 }}>
                        {emptyField(data.jobseeker_phone1.trim())}
                      </span>
                      <IoCallOutline
                        className="phone-icon"
                        size={22}
                        style={{ verticalAlign: "middle", cursor: "pointer" }}
                        onClick={() =>
                          handlePhoneClick(
                            data.jobseeker_phone1,
                            data.jobseeker_id
                          )
                        }
                        title="Call"
                      />{" "}
                      <IoMdCopy
                        className="copy-icon"
                        size={22}
                        style={{ verticalAlign: "middle", cursor: "pointer" }}
                        onClick={() =>
                          handleCopyClick(
                            data.jobseeker_phone1,
                            data.jobseeker_id
                          )
                        }
                        title="Copy"
                      />{" "}
                    </div>
                  ) : (
                    "N/A"
                  )}
                </Col>
              </Row>

              <Row className="mt-2">
                <Col
                  xs="5"
                  className=" p-0 ps-3 fw-bold"
                  style={{ lineHeight: "inherit" }}
                >
                  Phone2 <span style={{ float: "right" }}> : </span>
                </Col>
                <Col xs="7">
                  {data.jobseeker_phone2 ? (
                    <div>
                      <span style={{ marginRight: 5 }}>
                        {emptyField(data.jobseeker_phone2.trim())}
                      </span>
                      <IoCallOutline
                        className="phone-icon"
                        size={22}
                        style={{ verticalAlign: "middle", cursor: "pointer" }}
                        onClick={() =>
                          handlePhoneClick(
                            data.jobseeker_phone2,
                            data.jobseeker_id
                          )
                        }
                        title="Call"
                      />{" "}
                      <IoMdCopy
                        className="copy-icon"
                        size={22}
                        style={{ verticalAlign: "middle", cursor: "pointer" }}
                        onClick={() =>
                          handleCopyClick(
                            data.jobseeker_phone2,
                            data.jobseeker_id
                          )
                        }
                        title="Copy"
                      />
                    </div>
                  ) : (
                    "N/A"
                  )}
                </Col>
              </Row>

              <Row className="mt-2">
                <Col
                  xs="5"
                  className=" p-0 ps-3 fw-bold"
                  style={{ lineHeight: "inherit" }}
                >
                  DOB<span style={{ float: "right" }}> : </span>
                </Col>
                <Col xs="7">
                  {data.jobseeker_date_of_birth
                    ? formatDate(data.jobseeker_date_of_birth)
                    : "N/A"}
                </Col>
              </Row>

              {/* <Row className="mt-2">
                     <Col
                       xs="5"
                       className="fw-bold p-0 ps-3"
                       style={{ lineHeight: "inherit" }}
                     >
                       Gender<span style={{ float: "right" }}> : </span>
                     </Col>
                     <Col xs="7">
                       {profileData.jobseeker_gender
                         ? profileData.jobseeker_gender
                         : "N/A"}
                     </Col>
                   </Row>
                   <Row className="mt-2">
                     <Col
                       xs="5"
                       className=" p-0 ps-3 fw-bold"
                       style={{ lineHeight: "inherit" }}
                     >
                       Marital Status<span style={{ float: "right" }}> : </span>
                     </Col>
                     <Col xs="7">
                       {profileData.jobseeker_marital_status
                         ? profileData.jobseeker_marital_status
                         : "N/A"}
                     </Col>
                   </Row> */}
              {/* <Row className="mt-2">
                     <Col
                       xs="5"
                       className=" p-0 ps-3 fw-bold"
                       style={{ lineHeight: "inherit" }}
                     >
                       Differently Abled<span style={{ float: "right" }}> : </span>
                     </Col>
                     <Col xs="7">
                       {profileData.jobseeker_differently_abled
                         ? capitalize(profileData.jobseeker_differently_abled)
                         : "N/A"}
                     </Col>
                   </Row> */}
              {/* <Row className="mt-2">
                     <Col
                       xs="5"
                       className=" p-0 ps-3 fw-bold"
                       style={{ lineHeight: "inherit" }}
                     >
                       Permanent Address<span style={{ float: "right" }}> : </span>
                     </Col>
                     <Col xs="7">
                       {profileData.jobseeker_permanent_address
                         ? capitalize(profileData.jobseeker_permanent_address)
                         : "N/A"}
                     </Col>
                   </Row> */}

              {/* <Row className="mt-2">
                     <Col
                       xs="5"
                       className=" p-0 ps-3 fw-bold"
                       style={{ lineHeight: "inherit" }}
                     >
                       Pin Code<span style={{ float: "right" }}> : </span>
                     </Col>
                     <Col xs="7">
                       {profileData.jobseeker_pincode
                         ? profileData.jobseeker_pincode
                         : "N/A"}
                     </Col>
                   </Row>
       
                   <Row className="mt-2">
                     <Col
                       xs="5"
                       className=" p-0 ps-3 fw-bold"
                       style={{ lineHeight: "inherit" }}
                     >
                       Home Town<span style={{ float: "right" }}> : </span>
                     </Col>
                     <Col xs="7">
                       {profileData.jobseeker_hometown
                         ? capitalize(profileData.jobseeker_hometown)
                         : "N/A"}
                     </Col>
                   </Row> */}
              <Row className="mt-2">
                <Col
                  xs="5"
                  className=" p-0 ps-3 fw-bold d-flex align-items-start"
                  style={{ lineHeight: "inherit" }}
                >
                  Current Location
                  <span className="ms-auto" style={{ alignSelf: "flex-start" }}>
                    {" "}
                    :{" "}
                  </span>
                </Col>
                <Col xs="7">
                  {data.jobseeker_location
                    ? capitalize(data.jobseeker_location.label)
                    : "N/A"}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs="5"
                  className="p-0 ps-3 fw-bold d-flex align-items-start"
                  style={{ lineHeight: "inherit" }}
                >
                  Preferred Location
                  <span className="ms-auto" style={{ alignSelf: "flex-start" }}>
                    {" "}
                    :{" "}
                  </span>
                </Col>
                <Col xs="7">
                  {data.jobseeker_preferred_location &&
                    data.jobseeker_preferred_location.length > 0
                    ? data.jobseeker_preferred_location
                      .map((location) => capitalize(location.label))
                      .join(", ")
                    : "N/A"}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs="5"
                  className=" p-0 ps-3 fw-bold d-flex align-items-start"
                  style={{ lineHeight: "inherit" }}
                >
                  Total Experience
                  <span className="ms-auto" style={{ alignSelf: "flex-start" }}>
                    {" "}
                    :{" "}
                  </span>
                </Col>
                <Col xs="7">
                  {data.total_exp_years >= 0 ||
                    data.total_exp_months >= 0
                    ? formatExperienceYearAndMonth(
                      parseInt(data.total_exp_years),
                      parseInt(data.total_exp_months)
                    )
                    : "N/A"}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs="5"
                  className=" p-0 ps-3 fw-bold d-flex align-items-start"
                  style={{ lineHeight: "inherit" }}
                >
                  Relevant Experience
                  <span className="ms-auto" style={{ alignSelf: "flex-start" }}>
                    {" "}
                    :{" "}
                  </span>
                </Col>
                <Col xs="7">
                  {data.relevant_exp_years >= 0 ||
                    data.relevant_exp_months >= 0
                    ? formatExperienceYearAndMonth(
                      parseInt(data.relevant_exp_years),
                      parseInt(data.relevant_exp_months)
                    )
                    : "N/A"}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs="5"
                  className="p-0 ps-3 fw-bold d-flex align-items-start"
                  style={{ lineHeight: "inherit" }}
                >
                  Notice period
                  <span className="ms-auto" style={{ alignSelf: "flex-start" }}>
                    {" "}
                    :{" "}
                  </span>
                </Col>
                <Col xs="7">
                  {data.jobseeker_notice_period
                    ? `${data.jobseeker_notice_period} Days`
                    : "N/A"}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs="5"
                  className=" p-0 ps-3 fw-bold d-flex align-items-start"
                  style={{ lineHeight: "inherit" }}
                >
                  Job Preferences
                  <span className="ms-auto" style={{ alignSelf: "flex-start" }}>
                    {" "}
                    :{" "}
                  </span>
                </Col>
                <Col xs="7">
                  {data.jobseeker_preferred_job_type
                    ? jobTypeOptions.find(
                      (option) =>
                        option.value == data.jobseeker_preferred_job_type
                    )?.label
                    : "N/A"}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs="5"
                  className="p-0 ps-3 fw-bold d-flex align-items-start"
                  style={{ lineHeight: "inherit" }}
                >
                  Shift Preference
                  <span className="ms-auto" style={{ alignSelf: "flex-start" }}>
                    {" "}
                    :{" "}
                  </span>
                </Col>
                <Col xs="7">
                  {data.jobseeker_preferred_shift
                    ? data.jobseeker_preferred_shift
                      .split(",")
                      .map(
                        (shift) =>
                          shiftTypeOptions.find(
                            (option) => option.value === shift
                          )?.label
                      )
                      .join(", ")
                    : "N/A"}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs="5"
                  className=" p-0 ps-3 fw-bold d-flex align-items-start"
                  style={{ lineHeight: "inherit" }}
                >
                  Foreign Work Permit
                  <span className="ms-auto" style={{ alignSelf: "flex-start" }}>
                    {" "}
                    :{" "}
                  </span>
                </Col>
                <Col xs="7">
                  {data.jobseeker_work_permit_for_other_countries &&
                    data.jobseeker_work_permit_for_other_countries.length > 0
                    ? data.jobseeker_work_permit_for_other_countries
                      .map((country) => capitalize(country.label))
                      .join(", ")
                    : "N/A"}
                </Col>
              </Row>
            </div>

            <hr />

            <div className="d-flex align-items-center justify-content-between mt-4">
              <h5 className="mb-0 me-2">Desired Career Profile</h5>
              {/* {type == "view" ? null : (
              <div className="ms-2">
                <div className="d-flex">
                  <Button
                    color="primary"
                    className="btn  btn-sm  "
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingRight: "1rem",
                      paddingLeft: "1rem",
                    }}
                    onClick={desiredCareerProfile}
                  >
                    <MdOutlineModeEdit size={18} style={{ marginRight: 2 }} />{" "}
                    Edit
                  </Button>
                </div>
              </div>
            )} */}
              {/* {type === "view" ? null : (
                <div className="ms-2">
                  <div className="d-flex">
                    <FiEdit
                      className="edit-icon"
                      size={22}
                      onClick={desiredCareerProfile}
                      title="Edit"
                    />
                  </div>
                </div>
              )} */}
            </div>
            <div className="mt-3 ps-2">
              <Row className="mt-4">
                <Col
                  xs="5"
                  className=" p-0 ps-3 fw-bold d-flex align-items-start"
                  style={{ lineHeight: "inherit" }}
                >
                  Job Title
                  <span className="ms-auto" style={{ alignSelf: "flex-start" }}>
                    {" "}
                    :{" "}
                  </span>
                </Col>
                <Col xs="7">
                  {data.jobseeker_preferred_job_title
                    ? capitalize(data.jobseeker_preferred_job_title)
                    : "N/A"}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs="5"
                  className=" p-0 ps-3 fw-bold d-flex align-items-start"
                  style={{ lineHeight: "inherit" }}
                >
                  Desired Industry
                  <span className="ms-auto" style={{ alignSelf: "flex-start" }}>
                    {" "}
                    :{" "}
                  </span>
                </Col>
                <Col xs="7">
                  {data.jobseeker_preferred_industry &&
                    data.jobseeker_preferred_industry.label
                    ? capitalize(data.jobseeker_preferred_industry.label)
                    : "N/A"}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col
                  xs="5"
                  className=" p-0 ps-3 fw-bold d-flex align-items-start"
                  style={{ lineHeight: "inherit" }}
                >
                  Functional Area
                  <span className="ms-auto" style={{ alignSelf: "flex-start" }}>
                    {" "}
                    :{" "}
                  </span>
                </Col>
                <Col xs="7">
                  {data.jobseeker_preferred_industry &&
                    data.jobseeker_preferred_department.label
                    ? capitalize(data.jobseeker_preferred_department.label)
                    : "N/A"}
                </Col>
              </Row>
              {/* <Row className="mt-2">
              <Col
                xs="5"
                className=" p-0 ps-3 fw-bold"
                style={{ lineHeight: "inherit" }}
              >
                Job Preferences<span style={{ float: "right" }}> : </span>
              </Col>
              <Col xs="7">
                {profileData.jobseeker_preferred_job_type
                  ? jobTypeOptions.find(
                      (option) =>
                        option.value == profileData.jobseeker_preferred_job_type
                    )?.label
                  : "N/A"}
              </Col>
            </Row> */}
              <Row className="mt-2">
                <Col
                  xs="5"
                  className=" p-0 ps-3 fw-bold d-flex align-items-start"
                  style={{ lineHeight: "inherit" }}
                >
                  Employment Type
                  <span className="ms-auto" style={{ alignSelf: "flex-start" }}>
                    {" "}
                    :{" "}
                  </span>
                </Col>
                <Col xs="7">
                  {data.jobseeker_preferred_employment_type
                    ? employmentTypeOptions.find(
                      (option) =>
                        option.value ==
                        data.jobseeker_preferred_employment_type
                    )?.label
                    : "N/A"}
                </Col>
              </Row>
              {/* <Row className="mt-2">
              <Col
                xs="5"
                className="p-0 ps-3 fw-bold"
                style={{ lineHeight: "inherit" }}
              >
                Shift Preference
                <span style={{ float: "right" }}> : </span>
              </Col>
              <Col xs="7">
                {profileData.jobseeker_preferred_shift
                  ? profileData.jobseeker_preferred_shift
                      .split(",")
                      .map(
                        (shift) =>
                          shiftTypeOptions.find(
                            (option) => option.value === shift
                          )?.label
                      )
                      .join(", ")
                  : "N/A"}
              </Col>
            </Row> */}
              {/* <Row className="mt-2">
              <Col
                xs="5"
                className=" p-0 ps-3 fw-bold"
                style={{ lineHeight: "inherit" }}
              >
                Expected CTC<span style={{ float: "right" }}> : </span>
              </Col>
              <Col xs="7">
                {profileData.jobseeker_preferred_salary
                  ? `${
                      profileData.jobseeker_preferred_salary
                    } (${convertNumberToWords(
                      profileData.jobseeker_preferred_salary
                    )})`
                  : "N/A"}
              </Col>
            </Row>
          */}
            </div>
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={props.toggleModal}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ViewCandidateDetailModal;
